import { defaultIeltsTheme, ieltsThemeAtom } from "@/store/home";
import { themeData } from "@/theme/tokens";
import { IeltsTheme } from "@/types";
import { useAtom } from "jotai";

// Token definitions live in `@/theme/tokens` so they can be imported from
// `_document` without pulling in jotai. Re-exported here to keep the existing
// import paths working.
export { themeData } from "@/theme/tokens";
export type { IeltsThemeObject } from "@/theme/tokens";

type Props = {
  theme?: IeltsTheme;
};

export default function useIeltsTheme(props?: Props) {
  const [themeStore] = useAtom(ieltsThemeAtom);
  const currentTheme = props?.theme || themeStore || defaultIeltsTheme;
  return {
    theme: themeData[currentTheme],
  };
}
